export enum ICON_TYPE {
  DELETE = 'DELETE',
  CLOSE = 'CLOSE',
  BROWSE = 'BROWSE',
  ARROW_LINE_UP = 'ARROW_LINE_UP',
}
